module.exports = __webpack_public_path__ + "media/metal_sheet_1.06be24bf.mp3";